import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Layout from "../layouts/layout";
import SectionOne from "../containers/_settings/sectionOne";
import SectionTwo from "../containers/_settings/sectionTwo";
import SectionThree from "../containers/_settings/sectionThree";
import SectionForms from "../containers/_settings/sectionForms";
import PROFILE from "../api/services/PROFILE";
import Loader from "../components/loader";
import styles from "../styles/_screens/settings.module.scss";

const Settings = () => {
  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  const [formdata, setFormdata] = useState({
    id: businessId,
    waitingListMode: "",
    isConfirmEnabled: "",
    businesssScheduleAllowedFor: "",
    is24HoursReminderDisabled: "",
    is3HoursReminderDisabled: "",
    businessCancellationPeriod: "",
    isMaxCapacityPerDayEnabled: "",
    maxCapacityPerDay: "",
    isSmartAlgorithmActive: "",
    businessServiceSpan: "",
    canBookMoreInServices: "",
    cancellationText: "",
    isClientRegistrationConfirmationRequired: "",
    showCombinedServicesToClients: "",
    communicationChannel: "whatsapp",
    preventMessageOnClientAdd: "",
    sendFormOnClientJoin: false,
    formOnClientJoin: "",
  });

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [resStatus, setResStatus] = useState(null);

  // FETCH PROFILE DETAILS
  useEffect(() => {
    setResStatus(true);
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await PROFILE.get();

        setFormdata({
          waitingListMode: res.data.waiting_list_mode,
          isConfirmEnabled: res.data.isConfirmEnabled,
          businesssScheduleAllowedFor: res.data.businesss_schedule_allowed_for,
          is24HoursReminderDisabled: res.data.is24HoursReminderDisabled,
          is3HoursReminderDisabled: res.data.is3HoursReminderDisabled,
          businessCancellationPeriod: res.data.business_cancellation_period,
          isMaxCapacityPerDayEnabled: res.data.isMaxCapacityPerDayEnabled,
          maxCapacityPerDay: res.data.maxCapacityPerDay || "",
          isSmartAlgorithmActive: res.data.isSmartAlgorithmActive,
          businessServiceSpan: res.data.businessServiceSpan,
          canBookMoreInServices: res.data.canBookMoreInServices,
          cancellationText: res.data.cancellationText,
          isClientRegistrationConfirmationRequired: res.data.isClientRegistrationConfirmationRequired,
          showCombinedServicesToClients: res.data.showCombinedServicesToClients,
          communicationChannel: res.data.disableWhatsAppMessageToClient === true ? "sms" : "whatsapp",
          preventMessageOnClientAdd: res.data.preventMessageOnClientAdd,
          sendFormOnClientJoin: res.data.sendFormOnClientJoin || false,
          formOnClientJoin: res.data.formOnClientJoin || "",
        });
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    fetchData();
  }, [resStatus]);

  // UPDATE PROFILE
  const handleSubmit = async () => {
    setLoading2(true);
    try {
      let payload = {
        id: businessId,
        waiting_list_mode: formdata.waitingListMode,
        isConfirmEnabled: formdata.isConfirmEnabled,
        businesss_schedule_allowed_for: formdata.businesssScheduleAllowedFor,
        is24HoursReminderDisabled: formdata.is24HoursReminderDisabled,
        is3HoursReminderDisabled: formdata.is3HoursReminderDisabled,
        business_cancellation_period: formdata.businessCancellationPeriod,
        isMaxCapacityPerDayEnabled: formdata.isMaxCapacityPerDayEnabled,
        maxCapacityPerDay: formdata.maxCapacityPerDay,
        isSmartAlgorithmActive: formdata.isSmartAlgorithmActive,
        businessServiceSpan: formdata.businessServiceSpan,
        canBookMoreInServices: formdata.canBookMoreInServices,
        cancellationText: formdata.cancellationText,
        isClientRegistrationConfirmationRequired: formdata.isClientRegistrationConfirmationRequired,
        showCombinedServicesToClients: formdata.showCombinedServicesToClients,
        disableWhatsAppMessageToClient: formdata.communicationChannel !== "whatsapp",
        disableSMSMessageToClient: formdata.communicationChannel === "whatsapp",
        preventMessageOnClientAdd: formdata.preventMessageOnClientAdd,
        sendFormOnClientJoin: formdata.sendFormOnClientJoin,
        formOnClientJoin: formdata.formOnClientJoin,
      };

      const res = await PROFILE.update(payload);

      if (res.status === 200) {
        toast.success("עודכן בהצלחה!");
        setResStatus(true);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
    setLoading2(false);
  };

  // HANDLE INPUT CHANGE
  const handleChange = (e) => {
    setFormdata((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  if (loading || !formdata.waitingListMode) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <Loader />
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.sections}>
            {/* SECTION ONE */}
            <SectionOne data={formdata} handleChange={handleChange} />

            {/* SECTION TWO */}
            <SectionTwo data={formdata} handleChange={handleChange} />

            {/* SECTION THREE */}
            <SectionThree data={formdata} handleChange={handleChange} />

            {/* SECTION FORMS */}
            <SectionForms data={formdata} handleChange={handleChange} />
          </div>
        </div>
        <button onClick={handleSubmit} className={styles.saveBtn}>
          שמירת שינויים
        </button>
      </div>
    </Layout>
  );
};

export default Settings;
